import React from 'react';
import { faqs } from './faqData';
import FaqItem from './FaqItem';

const FaqList = () => (
  <section className="py-20 bg-brand-dark border-t border-white/5">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <div className="space-y-4">
        {faqs.map((faq, i) => (
          <FaqItem key={i} faq={faq} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default FaqList;